import React from 'react'
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { clearStatus } from "./scenarioApprovalSlice";

function SharedComponent() {
    const dispatch = useDispatch();
    const define = useSelector((state) => state.scenarioApproval);
    const {
        isSuccess,
        isSuccess_Info,
        isFailed,
        isFailed_Info,
        isError,
        isError_Info,
    } = define;

    const handleCloseSnackbar = () => {
        dispatch(clearStatus());
    };
    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isSuccess}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%" }}>
                    {isSuccess_Info}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isFailed}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} severity="info" sx={{ width: "100%" }}>
                    {isFailed_Info}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={isError}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: "100%" }}>
                     {isError_Info}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default SharedComponent
